import BasePropertyView from 'BasePropertyView.js';
import Template from 'workflow/properties/main/name.ejs';

class MainCommentWorkflowView extends BasePropertyView {

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    render() {
        
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainCommentWorkflowView;
